/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IAwardKitSkuDataState } from "Interfaces/SiteContent/IAwardKitSkuDataState";
import { IAwardKitSkuOption } from "Interfaces/SiteContent/IAwardKitSkuOption";

/**
 * Returns the Award Kit SKU option list.
 * @param awardKitSkuState
 */
export const getAwardKitSkuOptionList = (
  awardKitSkuState: IAwardKitSkuDataState
): IAwardKitSkuOption[] => awardKitSkuState.awardKitSkuOptionList;

/**
 * Returns the Award Kit SKU error.
 * @param awardKitSkuState
 */
export const getAwardKitSkuLoadError = (awardKitSkuState: IAwardKitSkuDataState): string =>
  awardKitSkuState.awardKitSkuLoadError;
